import script from "./home.view.vue?vue&type=script&setup=true&lang=js"
export * from "./home.view.vue?vue&type=script&setup=true&lang=js"

import "./home.view.vue?vue&type=style&index=0&id=c440a996&lang=css"

const __exports__ = script;

export default __exports__